export default __webpack_public_path__ + "static/media/CapaFileRar.6babb2ac.svg";